import { useEffect } from 'react';
import Layout from '../../../components/feature/Layout';
import SchemaOrg from '../../../components/base/SchemaOrg';

export default function TaoyuanPipePage() {
  useEffect(() => {
    const pageTitle = '桃園通水管｜專業水管疏通服務｜永業環保';
    const pageDesc = '永業環保提供桃園地區專業通水管服務，20年經驗，快速到府，水管堵塞、排水不良立即處理。服務桃園市、中壢、平鎮、八德等地區，24小時緊急服務，政府認證，收費透明。';
    const pageKeywords = '桃園通水管,桃園水管疏通,桃園水管堵塞,中壢通水管,平鎮水管疏通';
    const pageUrl = `${siteUrl}/seo/taoyuan-pipe`;

    document.title = pageTitle;

    const setMeta = (selector: string, attr: string, value: string) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };

    setMeta('meta[name="description"]', 'content', pageDesc);
    setMeta('meta[name="keywords"]', 'content', pageKeywords);
    setMeta('link[rel="canonical"]', 'href', pageUrl);
    setMeta('meta[property="og:title"]', 'content', pageTitle);
    setMeta('meta[property="og:description"]', 'content', pageDesc);
    setMeta('meta[property="og:url"]', 'content', pageUrl);
    setMeta('meta[name="twitter:title"]', 'content', pageTitle);
    setMeta('meta[name="twitter:description"]', 'content', pageDesc);
  }, [siteUrl]);

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const serviceAreas = [
    { name: '桃園區', cases: 156 },
    { name: '中壢區', cases: 142 },
    { name: '平鎮區', cases: 98 },
    { name: '八德區', cases: 87 },
    { name: '楊梅區', cases: 76 },
    { name: '蘆竹區', cases: 65 },
    { name: '龜山區', cases: 54 },
    { name: '龍潭區', cases: 43 },
    { name: '大溪區', cases: 38 },
    { name: '觀音區', cases: 32 },
    { name: '新屋區', cases: 28 },
    { name: '大園區', cases: 25 }
  ];

  const taoyuanCases = [
    {
      title: '桃園市區住宅廚房水管堵塞',
      area: '桃園區',
      date: '2024年1月',
      problem: '廚房水槽排水緩慢，水管內有油脂堆積',
      solution: '使用高壓水刀清除油脂，並進行管線內視鏡檢查',
      result: '排水恢復正常，建議定期保養',
      image: 'https://public.readdy.ai/ai/img_res/4289af2fc12fbd35da2edfc2d601075c.jpg'
    },
    {
      title: '中壢區餐廳主排水管疏通',
      area: '中壢區',
      date: '2024年2月',
      problem: '餐廳主排水管嚴重堵塞，廢水回流',
      solution: '水刀高壓疏通配合專業藥劑處理',
      result: '完全疏通，排水順暢，無異味',
      image: 'https://readdy.ai/api/search-image?query=Restaurant%20commercial%20kitchen%20drain%20pipe%20cleaning%20service%2C%20professional%20worker%20in%20uniform%20operating%20water%20jet%20equipment%2C%20large%20diameter%20pipe%20with%20grease%20buildup%20being%20cleaned%2C%20industrial%20kitchen%20environment%2C%20bright%20overhead%20lighting%2C%20technical%20documentation%20scene&width=800&height=600&seq=taoyuan-case-2&orientation=landscape'
    },
    {
      title: '平鎮區透天厝化糞池管線疏通',
      area: '平鎮區',
      date: '2024年3月',
      problem: '化糞池連接管線堵塞，馬桶無法正常使用',
      solution: '專業疏通設備清理管線，並清理化糞池',
      result: '管線暢通，馬桶恢復正常使用',
      image: 'https://readdy.ai/api/search-image?query=Septic%20tank%20pipe%20cleaning%20service%20for%20townhouse%2C%20professional%20technician%20with%20specialized%20equipment%20working%20on%20underground%20drainage%20system%2C%20outdoor%20residential%20setting%2C%20safety%20equipment%20visible%2C%20clear%20blue%20sky%2C%20professional%20service%20documentation%20style&width=800&height=600&seq=taoyuan-case-3&orientation=landscape'
    }
  ];

  const whyChooseUs = [
    {
      icon: 'ri-map-pin-line',
      title: '深耕桃園20年',
      description: '熟悉桃園各區管線特性，快速診斷問題'
    },
    {
      icon: 'ri-time-line',
      title: '30分鐘快速到府',
      description: '桃園市區30分鐘內到達，其他區域1小時內'
    },
    {
      icon: 'ri-24-hours-line',
      title: '24小時緊急服務',
      description: '全年無休，隨時待命處理緊急狀況'
    },
    {
      icon: 'ri-shield-check-line',
      title: '政府認證合格',
      description: '擁有專業證照，施工品質有保障'
    }
  ];

  const faqItems = [
    {
      question: '桃園通水管的費用大概多少？',
      answer: '一般住宅水管疏通費用約 $1,500-$3,000，實際費用依堵塞程度和管線長度而定。我們提供免費現場評估，報價透明，絕不額外加價。'
    },
    {
      question: '桃園哪些區域有提供服務？',
      answer: '我們服務桃園市全區，包括桃園區、中壢區、平鎮區、八德區、楊梅區、蘆竹區、龜山區、龍潭區、大溪區、觀音區、新屋區、大園區等13個行政區。'
    },
    {
      question: '多久可以到府服務？',
      answer: '桃園市區（桃園區、中壢區）約30分鐘內到達，其他區域約1小時內到達。緊急狀況我們會優先安排，盡快為您解決問題。'
    },
    {
      question: '水管堵塞的常見原因有哪些？',
      answer: '常見原因包括：廚房油脂堆積、毛髮堵塞、異物掉入、管線老化、樹根入侵等。定期保養可以有效預防堵塞問題。'
    },
    {
      question: '你們使用什麼方法疏通水管？',
      answer: '我們使用高壓水刀疏通技術，配合內視鏡檢查，能徹底清除堵塞物且不傷管線。必要時會使用環保藥劑輔助，絕不使用強酸強鹼。'
    }
  ];

  const schemas = [
    {
      '@context': 'https://schema.org',
      '@type': 'Service',
      '@id': `${siteUrl}/seo/taoyuan-pipe#service`,
      name: '桃園通水管服務',
      description: '永業環保提供桃園地區專業通水管服務，20年經驗，快速到府，水管堵塞、排水不良立即處理。',
      provider: {
        '@type': 'LocalBusiness',
        name: '永業環保',
        telephone: '0800-281-281',
        url: siteUrl,
        address: {
          '@type': 'PostalAddress',
          addressRegion: '桃園市',
          addressCountry: 'TW'
        }
      },
      areaServed: [
        { '@type': 'City', name: '桃園區' },
        { '@type': 'City', name: '中壢區' },
        { '@type': 'City', name: '平鎮區' },
        { '@type': 'City', name: '八德區' },
        { '@type': 'City', name: '楊梅區' },
        { '@type': 'City', name: '蘆竹區' },
        { '@type': 'City', name: '龜山區' },
        { '@type': 'City', name: '龍潭區' },
        { '@type': 'City', name: '大溪區' },
        { '@type': 'City', name: '觀音區' },
        { '@type': 'City', name: '新屋區' },
        { '@type': 'City', name: '大園區' }
      ],
      offers: {
        '@type': 'Offer',
        priceRange: 'NT$1,500-NT$3,000',
        priceCurrency: 'TWD'
      }
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      '@id': `${siteUrl}/seo/taoyuan-pipe#faqpage`,
      mainEntity: faqItems.map(faq => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer
        }
      }))
    },
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      '@id': `${siteUrl}/seo/taoyuan-pipe#breadcrumb`,
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首頁', item: siteUrl },
        { '@type': 'ListItem', position: 2, name: '桃園通水管', item: `${siteUrl}/seo/taoyuan-pipe` }
      ]
    }
  ];

  return (
    <Layout>
      <SchemaOrg schema={schemas} />
      <div className="pt-24">
        {/* Hero Section */}
        <section className="relative bg-gradient-to-br from-teal-50 via-white to-cyan-50 py-20">
          <div className="max-w-7xl mx-auto px-4">
            <div className="text-center mb-12">
              <h1 className="text-5xl font-bold text-gray-900 mb-6">
                桃園通水管專業服務
              </h1>
              <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto">
                深耕桃園20年，服務超過2,000個家庭與商家<br/>
                水管堵塞、排水不良，30分鐘快速到府，立即解決您的困擾
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <a 
                  href="/contact" 
                  className="inline-flex items-center gap-2 bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-line text-xl"></i>
                  立即預約服務
                </a>
                <a 
                  href="#service-areas" 
                  className="inline-flex items-center gap-2 bg-white text-teal-600 px-8 py-4 rounded-lg font-semibold border-2 border-teal-600 hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-map-pin-line text-xl"></i>
                  查看服務區域
                </a>
              </div>
            </div>

            {/* Quick Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16">
              <div className="bg-white rounded-xl p-6 text-center shadow-md">
                <div className="text-4xl font-bold text-teal-600 mb-2">20+</div>
                <div className="text-gray-600">服務年資</div>
              </div>
              <div className="bg-white rounded-xl p-6 text-center shadow-md">
                <div className="text-4xl font-bold text-teal-600 mb-2">2000+</div>
                <div className="text-gray-600">服務案例</div>
              </div>
              <div className="bg-white rounded-xl p-6 text-center shadow-md">
                <div className="text-4xl font-bold text-teal-600 mb-2">30分</div>
                <div className="text-gray-600">快速到府</div>
              </div>
              <div className="bg-white rounded-xl p-6 text-center shadow-md">
                <div className="text-4xl font-bold text-teal-600 mb-2">24hr</div>
                <div className="text-gray-600">緊急服務</div>
              </div>
            </div>
          </div>
        </section>

        {/* Service Areas */}
        <section id="service-areas" className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">桃園全區服務範圍</h2>
              <p className="text-lg text-gray-600">服務桃園市13個行政區，累積超過2,000個成功案例</p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {serviceAreas.map((area, index) => (
                <div 
                  key={index}
                  className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-xl p-6 hover:shadow-lg transition-all hover:-translate-y-1 cursor-pointer"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center">
                      <i className="ri-map-pin-fill text-white text-xl"></i>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900">{area.name}</h3>
                  </div>
                  <p className="text-gray-600">已服務 <strong className="text-teal-600">{area.cases}</strong> 個案例</p>
                </div>
              ))}
            </div>

            {/* Map Placeholder */}
            <div className="mt-12 bg-gray-100 rounded-2xl overflow-hidden shadow-lg">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d115594.8744181033!2d121.22307!3d24.99362!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x34681e1f456e850b%3A0xd9d9d35c8c9c8c9c!2z5qGD5ZyS5biC!5e0!3m2!1szh-TW!2stw!4v1234567890"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="桃園服務區域地圖"
              ></iframe>
            </div>
          </div>
        </section>

        {/* Why Choose Us */}
        <section className="py-20 bg-gradient-to-br from-gray-50 to-teal-50">
          <div className="max-w-7xl mx-auto px-4">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">為什麼選擇永業環保</h2>
              <p className="text-lg text-gray-600">深耕桃園20年，最了解在地需求的專業團隊</p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {whyChooseUs.map((item, index) => (
                <div 
                  key={index}
                  className="bg-white rounded-2xl p-8 text-center hover:shadow-xl transition-all hover:-translate-y-2"
                >
                  <div className="w-20 h-20 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-2xl flex items-center justify-center mx-auto mb-6">
                    <i className={`${item.icon} text-4xl text-white`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{item.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Taoyuan Cases */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">桃園地區施工案例</h2>
              <p className="text-lg text-gray-600">真實案例分享，專業品質看得見</p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {taoyuanCases.map((caseItem, index) => (
                <div 
                  key={index}
                  className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2"
                >
                  <div className="relative h-64 overflow-hidden">
                    <img 
                      src={caseItem.image}
                      alt={caseItem.title}
                      className="w-full h-full object-cover hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute top-4 left-4">
                      <span className="bg-teal-600 text-white px-4 py-2 rounded-full text-sm font-semibold">
                        {caseItem.area}
                      </span>
                    </div>
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-3">{caseItem.title}</h3>
                    <div className="space-y-3 text-sm">
                      <div className="flex items-start gap-2">
                        <i className="ri-calendar-line text-teal-600 mt-1"></i>
                        <span className="text-gray-600">{caseItem.date}</span>
                      </div>
                      <div className="flex items-start gap-2">
                        <i className="ri-error-warning-line text-orange-500 mt-1"></i>
                        <div>
                          <strong className="text-gray-900">問題：</strong>
                          <span className="text-gray-600">{caseItem.problem}</span>
                        </div>
                      </div>
                      <div className="flex items-start gap-2">
                        <i className="ri-tools-line text-blue-600 mt-1"></i>
                        <div>
                          <strong className="text-gray-900">處理：</strong>
                          <span className="text-gray-600">{caseItem.solution}</span>
                        </div>
                      </div>
                      <div className="flex items-start gap-2">
                        <i className="ri-checkbox-circle-line text-green-600 mt-1"></i>
                        <div>
                          <strong className="text-gray-900">結果：</strong>
                          <span className="text-gray-600">{caseItem.result}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="text-center mt-12">
              <a 
                href="/cases" 
                className="inline-flex items-center gap-2 text-teal-600 font-semibold hover:text-teal-700 cursor-pointer"
              >
                查看更多施工案例
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-20 bg-gradient-to-br from-teal-50 to-cyan-50">
          <div className="max-w-4xl mx-auto px-4">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">常見問題</h2>
              <p className="text-lg text-gray-600">關於桃園通水管服務的常見疑問</p>
            </div>

            <div className="space-y-6">
              {faqItems.map((faq, index) => (
                <div 
                  key={index}
                  className="bg-white rounded-2xl p-8 shadow-md hover:shadow-lg transition-shadow"
                >
                  <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-start gap-3">
                    <i className="ri-question-line text-teal-600 text-2xl"></i>
                    {faq.question}
                  </h3>
                  <p className="text-gray-600 leading-relaxed pl-11">{faq.answer}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-r from-teal-600 to-cyan-600">
          <div className="max-w-4xl mx-auto px-4 text-center">
            <h2 className="text-4xl font-bold text-white mb-6">
              桃園水管堵塞？立即聯絡我們
            </h2>
            <p className="text-xl text-teal-50 mb-8">
              30分鐘快速到府，24小時緊急服務<br/>
              專業團隊為您解決所有水管問題
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a 
                href="/contact" 
                className="inline-flex items-center gap-2 bg-white text-teal-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                立即預約服務
              </a>
              <a 
                href="/services/pipe-cleaning" 
                className="inline-flex items-center gap-2 bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line text-xl"></i>
                了解更多服務
              </a>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
}